import Vue from "vue";
import VueRouter from "vue-router";
import homeIndex from "@/views/home/homeIndex.vue";
Vue.use(VueRouter);

const routes = [
	//首页
    {
        path: "/",
        redirect: 'homeIndex',
        meta:{
             title: '铁公基·爱票据',
             keepAlive:true
        }
    },
    {
      path: "/homeIndex",
      name: "homeIndex",
    	meta:{
    		title: '铁公基·爱票据',
    		keepAlive:true
    	},
      component: () =>
        import("../views/home/homeIndex.vue")
    },
    {
      path: "/login",
      name: "login",
    	meta:{
    		title: '登录',
    		keepAlive:false
    	},
      component: () =>
        import("../views/login.vue")
    },
    //资方
    {
      path: "/capitalIndex",
      name: "capitalIndex",
    	meta:{
    		title: '平台资方',
    		keepAlive:true
    	},
      component: () =>
        import("../views/capital/index.vue")
    },
    //客服
    {
      path: "/customerIndex",
      name: "customerIndex",
    	meta:{
    		title: '客服',
    		keepAlive:true
    	},
      component: () =>
        import("../views/customer/index.vue")
    },
    {
      path: "/customerdDetail",
      name: "customerdDetail",
    	meta:{
    		title: '客服',
    		keepAlive:false
    	},
      component: () =>
        import("../views/customer/detail.vue")
    },
    //奖金计算器
    {
      path: "/counterIndex",
      name: "counterIndex",
    	meta:{
    		title: '计算器',
    		keepAlive:true
    	},
      component: () =>
        import("../views/counter/index.vue")
    },
    //推荐官
    {
      path: "/recommendone",
      name: "recommendone",
    	meta:{
    		title: '推荐官',
    		keepAlive:true
    	},
      component: () =>
        import("../views/recommend/stepone/index.vue")
    },
    {
      path: "/recommendtwo",
      name: "recommendtwo",
    	meta:{
    		title: '推荐官',
    		keepAlive:true
    	},
      component: () =>
        import("../views/recommend/steptwo/index.vue")
    },
    //奖励
    {
      path: "/rewardIndex",
      name: "rewardIndex",
    	meta:{
    		title: '推荐官',
    		keepAlive:true
    	},
      component: () =>
        import("../views/reward/index.vue")
    },
    {
      path: "/myreward",
      name: "myreward",
    	meta:{
    		title: '推荐官',
    		keepAlive:true
    	},
      component: () =>
        import("../views/reward/my.vue")
    },
    {
      path: "/bank",
      name: "bank",
    	meta:{
    		title: '推荐官',
    		keepAlive:false
    	},
      component: () =>
        import("../views/reward/bank/add.vue")
    },
    //海报
    {
      path: "/poster",
      name: "poster",
    	meta:{
    		title: '推荐官',
    		keepAlive:false
    	},
      component: () =>
        import("../views/reward/poster.vue")
    },
    //推荐人贴票列表
    {
      path: "/recommendlist",
      name: "recommendlist",
    	meta:{
    		title: '推荐官',
    		keepAlive:true
    	},
      component: () =>
        import("../views/reward/list/index.vue")
    },
    //追踪列表
    {
      path: "/tracklist",
      name: "tracklist",
    	meta:{
    		title: '推荐官',
    		keepAlive:false
    	},
      component: () =>
        import("../views/reward/list/tracklist.vue")
    },
    
    //规则
    {
      path: "/rule",
      name: "rule",
    	meta:{
    		title: '规则',
    		keepAlive:true
    	},
      component: () =>
        import("../views/recommend/rule.vue")
    },
    {
      path: "/myIndex",
      name: "myIndex",
    	meta:{
    		title: '我的',
    		keepAlive:true
    	},
      component: () =>
        import("../views/my/myIndex.vue")
    },
    //我的设置
    {
      path: "/myAccount",
      name: "myAccount",
    	meta:{
    		title: '我的设置',
    		keepAlive:false
    	},
      component: () =>
        import("../views/my/myAccount.vue")
    },
    {
        path: "/addDraft",
        name: "addDraft",
        meta:{
            title: '上传票面',
            keepAlive:true
        },
        component: () =>
            import("../views/add/add.vue")
    },
    {
        path: "/release",
        name: "release",
        meta:{
            title: '发布购票需求',
            keepAlive:true
        },
        component: () =>
            import("../views/add/release.vue")
    },
    {
        path: "/example",
        name: "example",
        meta:{
            title: '示例',
            keepAlive:false
        },
        component: () =>
            import("../views/add/example.vue")
    },
    {
        path: "/success",
        name: "success",
        meta:{
            title: '上传成功',
            keepAlive:false
        },
        component: () =>
            import("../views/add/success.vue")
    },
    {
        path: "/myAdd",
        name: "myAdd",
        meta:{
            title: '我的',
            keepAlive:true
        },
        component: () =>
            import("../views/my/list/myAdd.vue")
    },
    
    {
        path: "/myDetails",
        name: "myDetails",
        meta:{
            title: '详情',
            keepAlive:false
        },
        component: () =>
            import("../views/my/details/detail.vue")
    },
    //认证
    {
      path: "/attestationone",
      name: "attestationone",
    	meta:{
    		title: '认证',
    		keepAlive:true
    	},
      component: () =>
        import("../views/attestation/stepone/index.vue")
    },
    {
      path: "/attestationtwo",
      name: "attestationtwo",
    	meta:{
    		title: '认证',
    		keepAlive:true
    	},
      component: () =>
        import("../views/attestation/steptwo/index.vue")
    },
    {
      path: "/attestationthree",
      name: "attestationthree",
    	meta:{
    		title: '认证',
    		keepAlive:true
    	},
      component: () =>
        import("../views/attestation/stepthree/index.vue")
    },
    {
      path: "/attestationdetail",
      name: "attestationdetail",
    	meta:{
    		title: '认证',
    		keepAlive:true
    	},
      component: () =>
        import("../views/attestation/details/detail.vue")
    },
    {
        path: "/quotetoday",
        name: "quotetoday",
        meta:{
            title: '票据贴现最新报价',
            keepAlive:false
        },
        component: () =>
            import("../views/counter/bid.vue")
    },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
	  return new Promise((resolve, reject) => {
	    setTimeout(() => {
	      resolve({ x: 0, y: 0 })
	    }, 1)
	  })
	},
  routes,
});
export default router;
